
import React from 'react';
import { CardHeader, CardTitle } from '@/components/ui/card';

interface JourneyCardHeaderProps {
  icon: React.ReactNode;
  title: string;
}

const JourneyCardHeader: React.FC<JourneyCardHeaderProps> = ({ 
  icon, 
  title 
}) => {
  return (
    <CardHeader className="pb-2">
      <div className="flex items-center">
        {icon}
        <CardTitle className="text-lg">{title}</CardTitle>
      </div>
    </CardHeader>
  );
};

export default JourneyCardHeader;
